import {type Iso8601} from '@hconnect/common/types'
import {ExpertSystemWrapper, useExpertSystemEquipmentsWithNames} from '@widgets/expert-system'

type Props = {
  upmPlantId: string
  from: Iso8601
  to: Iso8601
}

export const ExpertSystemContainer = ({upmPlantId, from, to}: Props) => {
  const {
    data: expertSystemEquipmentsWithNames,
    error: expertSystemEquipmentError,
    isFetching: expertSystemEquipmentsFetching
  } = useExpertSystemEquipmentsWithNames({
    hierarchyId: upmPlantId,
    from,
    to
  })

  return (
    <ExpertSystemWrapper
      canDisplayMultiMonthData={true}
      expertSystemEquipments={expertSystemEquipmentsWithNames}
      isLoading={expertSystemEquipmentsFetching}
      error={expertSystemEquipmentError}
    />
  )
}
